<div class="bp-modal-body verification-modal">
  <div class="bp-modal-body-section">
    <div class="browser_screen__image_wrapper">
      <div class="browser_screen__image_container">
        <img src="assets/images/sad-smiley.svg" [alt]="'not_supported_browser_alt_text' | translate" />
      </div>
    </div>
    <div class="browser_screen__container">
      <div class="browser_screen__title">{{ "verification_browser_title" | translate }}</div>
      <div class="browser_screen__subtitle">{{ "verification_browser_subtitle" | translate }}</div>
      <!-- Use Chrome or Download Android and iOS apps -->
      @if (showChromeAppsMessage()) {
        <div class="browser_screen__chrome">
          <a href="https://www.google.com/chrome/" target="_blank">
            {{ "verification_browser_chrome" | translate }}
          </a>
        </div>
        <div class="browser_screen__alternative">{{ "verification_browser_alternative" | translate }}</div>
        <div class="browser_screen__platforms_images">
          <a [href]="getGooglePlayDownloadLink()" target="_blank">
            <img
              class="browser_screen__platforms_img"
              src="assets/images/playstore.svg"
              alt="Google Play Store" />
          </a>
          <a [href]="getAppStoreDownloadLink()" target="_blank">
            <img
              class="browser_screen__platforms_img"
              src="assets/images/appstore.svg"
              alt="Apple App Store" />
          </a>
        </div>
      }
      <!-- Download iOS App -->
      @if (showSafariMessage()) {
        <div class="browser_screen__download_mobile">{{ "verification_browser_download" | translate }}</div>
        <div class="browser_screen__platforms_images">
          <a [href]="getAppStoreDownloadLink()" target="_blank">
            <img
              class="browser_screen__platforms_img"
              src="assets/images/appstore.svg"
              alt="Apple App Store" />
          </a>
        </div>
      }
    </div>
  </div>
</div>
